<template>
  <img src="/images/promo/connect-features/ukrainian-banks-association.svg" alt="Ukrainian Banks Association" />
</template>

<script>
export default {};
</script>

